module.exports = __webpack_public_path__ + "static/index/img/baikal-104.ed9f0391.jpg";